export class HttpError extends Error {
  constructor(
    message: string,
    public readonly response: Response,
  ) {
    super(message);
    this.name = 'HttpError';
  }
}

export default async function safeFetch(
  url: string | URL,
  options?: RequestInit,
): Promise<Response> {
  if (!url) {
    throw new Error('Missing URL');
  }

  let response: Response;

  try {
    response = await fetch(url, options);
  } catch (error) {
    throw new Error(`Network request failed: ${url.toString()}`, {
      cause: error,
    });
  }

  if (!response.ok) {
    throw new HttpError(`HTTP ${response.status}: ${response.statusText}`, response);
  }

  return response;
}
